import { initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth'
import { getFirestore, collection, orderBy, limit, startAfter, query, getDocs, onSnapshot, doc, getDoc, updateDoc } from 'firebase/firestore'
import { getRemoteConfig, getValue, fetchAndActivate, setValue } from "firebase/remote-config";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import axios from 'axios'

const app = initializeApp({
    apiKey: "AIzaSyDiQb_pJfMDCoztEWx0E1ndUsmUz-h4x9s",
    authDomain: "credit-assegurances-vida.firebaseapp.com",
    projectId: "credit-assegurances-vida",
    storageBucket: "credit-assegurances-vida.appspot.com",
    messagingSenderId: "428557806941",
    appId: "1:428557806941:web:bf5e9edde560621f9eccb4",
    measurementId: "G-EZJCESDVFN"
});

const RCNAME = 'banner_urls_string';

const logOut = async () => {
    const au = getAuth(app);
    await signOut(au);
}

const getData = async (params) => {
    const db = getFirestore(app);
    const {coll, lim, start, order} = params;
/*     const q = start ? query(collection(db, coll), orderBy(order), startAt(start), limit(lim)) : 
                      query(collection(db, coll), orderBy(order), limit(lim)); */
    const q = query(collection(db, coll), orderBy(order), startAfter(start), limit(lim))
    const snapshot = await getDocs(q);  
//console.log(snapshot.docs)    
    return snapshot;
}

const getHook = (params, snapshot, error) => {
    const db = getFirestore(app);
    const {coll, lim, order} = params;
    const q = query(collection(db, coll), orderBy(order, 'desc'), limit(lim))
    return onSnapshot(q, snapshot, error);
};

const getWatchingHook = (params, snapshot, error) => {
    const db = getFirestore(app);
    const {coll, alertId} = params;
    return onSnapshot(doc(db, coll, alertId), snapshot, error);
};

const getWatchingReport = async (params) => {
    const db = getFirestore(app);
    const { alertId } = params;
    const pluspos = alertId.indexOf('+');
    const timestamp = Number(alertId.substring(0, pluspos));
    const d = new Date(timestamp);
    const phone = alertId.substring(pluspos);
    const y = d.getFullYear().toString();
    const m = (d.getMonth()+1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    const ref1 = doc( db, `crashReports/${y}/${m}/${day}/${phone}`, timestamp.toString());
    const ref2 = await getDoc(ref1);
    //const doc = ref2; // await getDoc(collection(ref1, `${day}/${phone}`), alertId)
    let ret = ref2.data();
    if(ret?.hasLocations) ret.report = (await getDoc(await doc(ref1, 'heavyData', 'loc'))).data();
    return ret;
    /* 
    db.collection('crashReports').doc(syear)
        .collection(smonth).doc(sday)
        .collection(sphone).doc(id.toString()
    */
    //return getDoc(doc(db, coll, alertId));
}

const getWatchingImpacts = async (params) => {
    const { alertId, hasAccelerations, impacts } = params;
//console.log(impacts, hasAccelerations)    
    let ret = [];
    if(hasAccelerations && !impacts) {
        const db = getFirestore(app);
        const pluspos = alertId.indexOf('+');
        const timestamp = Number(alertId.substring(0, pluspos));
        const d = new Date(timestamp);
        const phone = alertId.substring(pluspos);
        const y = d.getFullYear().toString();
        const m = (d.getMonth()+1).toString().padStart(2, '0');
        const day = d.getDate().toString().padStart(2, '0');
        ///crashReports C /2022 D /04 C /04 D /+34656609838 C /1649063541767 D /heavyData C /acc D
        const ref1 = await doc( db, `crashReports/${y}/${m}/${day}/${phone}/${timestamp.toString()}/heavyData/`, 'acc');
        const ref2 = await getDoc(ref1);
        ret = ref2?.data()?.accelerations.map(a => {
            const d = new Date(a.time || a.accTime)
            const time = `${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}.${d.getMilliseconds()}`
            return [time, a.accModule || a.mod]
        });
    }
    return ret;
}

const getSessionID = async (params) => {
    const { user } = params;
    const db = getFirestore(app);
    const ref = doc( db, `users/`, user);
    /* await updateDoc(ref, {
        "sessionIDs": deleteField()
    }); */
    const ref2 = await getDoc(ref);
    let ret = ref2.data();
    return ret?.sessionIDs ? ret?.sessionIDs[0] : 0;
}

const setSessionID = async (params) => {
    const { user, sessionID } = params;
    const db = getFirestore(app);
    const ref = doc( db, `users/`, user);
    /* await updateDoc(ref, {
        "sessionIDs": deleteField()
    }); */
    await updateDoc(ref, {
        "sessionIDs": [sessionID]
    })
    window.localStorage.setItem('sessionID', sessionID);
}

const getRCValue = async (v) => {
    let remoteConfig = getRemoteConfig(app);
    remoteConfig.settings.minimumFetchIntervalMillis = 1000;
    await fetchAndActivate(remoteConfig);
    const val = getValue(remoteConfig, v || RCNAME) || [];
    return val;
}

const setRCValue = async (v) => {
    const au = getAuth(app);
    const token = au.currentUser.accessToken;

    const headers = {
        "content-type": "application/json",
        "Authorization": `Bearer ${token}`
    }
    const data = {name: RCNAME, "value": v};
    try {
    const ret = await axios({
        method: "put",
        //url: "http://localhost:5001/credit-assegurances-vida/us-central1/set", 
        url: "https://us-central1-credit-assegurances-vida.cloudfunctions.net/set",
        data: data, 
        headers: headers
    });
//console.log(ret)
    } catch(e) { console.log(e)}
    return;
}

const uploadFile = async (f) => {
    const storage = getStorage();
    const storageRef = ref(storage, `banners/${f.name}`);
    try {
       await uploadBytes(storageRef, f);
    } catch(e) {
        console.log(e)
    }
    try {
        const pepe = await getDownloadURL(storageRef)
        return pepe;
    } catch(e) {}
    return null;
}
/* 
const setRCValue = (p, v) => {
    const remoteConfig = getRemoteConfig(app);
    setValue(remoteConfig, p, v);
}
 */
export { 
    app,
    initializeApp,
    signInWithEmailAndPassword,
    getFirestore,
    getAuth,
    logOut,
    getData,
    getHook,
    getWatchingHook,
    getWatchingReport,
    getWatchingImpacts,
    setSessionID,
    getSessionID,
    getRCValue,
    setRCValue,
    uploadFile
    //setRCValue
}